import type { GameData, ProductTypeCode } from '@/features/games/shared/types/game-data';

/** The only product types the auth gate applies to. */
const DOWNLOAD_PRODUCT_TYPES = ['download', 'download_free'] as const satisfies ProductTypeCode[];

export const isDownloadProductType = (productType: GameData['productType']): boolean =>
  Boolean(productType) && DOWNLOAD_PRODUCT_TYPES.includes(productType as never);

export interface GameAuthGateInput {
  /** The CTA would start a free trial (not owned, not member play). */
  isTrialDownload: boolean;
  productType: GameData['productType'];
  /** Session state is still resolving — decide nothing yet. */
  sessionLoading: boolean;
  isAuthenticated: boolean;
}

/** Gate an anonymous trial click on a download product; never while the session is still loading. */
export const needsGameAuthGate = ({
  isTrialDownload,
  productType,
  sessionLoading,
  isAuthenticated,
}: GameAuthGateInput): boolean =>
  isTrialDownload && isDownloadProductType(productType) && !sessionLoading && !isAuthenticated;
